import axios from 'axios'
import {CustomFieldTO} from 'generated/JavaTO'


export function fetchKostAuswertungCFDefs() {
	return axios.get<CustomFieldTO[]>('../json/cfDef/kostAuswertung')
}